import React, { FC, ReactNode } from 'react';
import { Tooltip as TooltipAnt } from 'antd';

interface ITooltip {
  children?: React.ReactNode;
  title: ReactNode;
}

const Tooltip: FC<ITooltip> = ({ children, title }) => (
  <TooltipAnt title={title} mouseEnterDelay={0.1} mouseLeaveDelay={0.1}>
    {children}
  </TooltipAnt>
);

export default Tooltip;
